/**
 * Packaging OS — Locked feature card.
 *
 * Reason-first layout per card-primitives-spec.md §2.3.
 * Lock icon is amber (var(--color-locked-icon)), never grey — locked is
 * intentional, not failed.
 */

interface LockedCardProps {
  title: string;
  reason: string;
}

export function LockedCard({ title, reason }: LockedCardProps): JSX.Element {
  return (
    <article className="po-card po-card--locked">
      <h3 className="po-card__title">
        <span aria-hidden="true" className="po-card__lock-icon">
          {/* Inline minimal lock SVG — no third-party asset */}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="11" width="16" height="9" rx="2" />
            <path d="M8 11V8a4 4 0 1 1 8 0v3" />
          </svg>
        </span>
        <span>{title}</span>
      </h3>
      <p className="po-card__body">{reason}</p>
    </article>
  );
}
